import React from 'react';

const RadioPlayer: React.FC = () => {
  return (
    <div className="radio-player">
      <h3>Now Spiller: Station Name</h3>
      {/* You can add your audio playback element or component here */}
      {/* For example: <audio controls src="your-audio-source.mp3"></audio> */}
    </div>
  );
};

export default RadioPlayer;
